import ApolloClient from 'apollo-boost';
import fetch from 'isomorphic-fetch';

export const getClient = apiUrl => (
  new ApolloClient({
    uri: apiUrl,
    fetch
  })
);
